<div class="w-100 float-left pl-4" *ngFor="let childOrg of childOrgs">
    <org [org]='childOrg' (deleteOrgEvent)="removeFromChild($event)" (editOrgEvent)="editOrg($event)"
         (refresh)="refreshLocal($event)"></org>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/org/childOrgs.html